import React, { useState,useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import ShareButton from './ShareButton';
import { hover } from '@testing-library/user-event/dist/hover';


export default function AboutUs() {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState({ adult: false, kids: false });
  const [hoveredOption, setHoveredOption] = useState(null);
  const [translateX, setTranslateX] = useState(0);
  const speed = 0.3; // Adjust speed (lower = faster)

  
  useEffect(() => {
    const interval = setInterval(() => {
      setTranslateX((prev) => (prev <= -images.length * 150 ? 0 : prev - speed));
    }, 20); // Smooth movement

    return () => clearInterval(interval);
  }, []);
  // Function to handle the toggle of the dropdown
  const toggleDropdown = (menu) => {
    setDropdownVisible((prevState) => ({
      adult: menu === 'adult' ? !prevState.adult : false,
      kids: menu === 'kids' ? !prevState.kids : false,
    }));
  };

  const handleClick = () => {
    navigate('/Contact-us');
  };

  // Function to handle hover effect
  const handleMouseEnter = (index) => {
    setHoveredOption(index);
  };

  const handleMouseLeave = () => {
    setHoveredOption(null);
  };
  // Function to handle hover-based dropdown visibility
  const handleMouseEnterDropdown = (menu) => {
    setDropdownVisible({
      adult: menu === 'adult',
      kids: menu === 'kids',
    });
  };

  const handleMouseLeaveDropdown = () => {
    setDropdownVisible({ adult: false, kids: false });
  };
  const images = [
 
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925243/my_uploads/dgy65lzqonyqkvd1ewyz.jpg",

    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925247/my_uploads/rvkenvmno9v1152cxj3l.jpg",
  
    
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925239/my_uploads/ltakhaovkvucxae9cbp7.jpg",
  
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925240/my_uploads/wrf85q4yx8x4lhhzdj9h.jpg",
 
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925245/my_uploads/sa9hyhwevkos9stmwkuv.jpg",
  
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925249/my_uploads/dchywmotm5dpp1q7svjr.jpg",
   
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925248/my_uploads/o4k2w5syhwzsx6fn0cyo.jpg",
  
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925241/my_uploads/gucsg097eng0dgo1orpc.jpg",

    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925241/my_uploads/f63fdixb5rkkrpo7rhrs.jpg",

    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925247/my_uploads/f8fdkgyw3nnedzt1hfyt.jpg",

    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925240/my_uploads/i6zojd6iq4cmmxfwugvt.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925244/my_uploads/lz1hjhlqvsbxvni5sivh.jpg",
    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925244/my_uploads/zmhpbe4okr68ukywgnrn.jpg",

    "https://res.cloudinary.com/dcuturlmb/image/upload/v1759925246/my_uploads/mg4iyrk8mgeqrg62yu3q.jpg",



 

    


  ];

  return (
    <>
      <div style={{ marginBottom: 10 , marginTop:-10}}>
        {/* Navigation Bar */}


        <div style={styles.container}>
          <div style={styles.mainContent}>
            {/* <h5
              style={{
                marginTop: 10,
                backgroundColor: "#071d49",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              About Us
            </h5> */}

            <p>
              Welcome to <i><strong style={{ color: "#A60065" }}>Wear & Wonder boutique</strong></i>, your go-to destination for stylish apparel and fun hobby-related products!
              We believe in making shopping for you and your little ones an exciting and seamless experience. Whether you're looking for the latest fashion trends,
              or creative activity kits, we've got something for every one.
            </p>
            <p>
              We are proud to share that 5% of our profits go directly to supporting charities dedicated to improving the lives of children in need.
              Your purchases not only bring joy to your own family but also help make a difference in the lives of others.
            </p>
            <p>
              At <i><strong style={{ color: "#A60065" }}>Wear & Wonder boutique</strong></i>, we are more than just an online store; we are a community committed to spreading positivity and giving back.
            </p>

            {/* <p style={{ marginLeft: -10, marginTop: 30, color: "#A60065" }}> */}
              <ShareButton style={{ marginLeft: -10, marginTop: 30, color: "#A60065" }} />
            {/* </p> */}
          </div>
        </div>

      </div>
     
            <hr style={{
        border: 0,
        height: "3px",
        marginBottom:5,
        marginTop:-10,
        backgroundImage: "linear-gradient(to right, #f0f0f0, #00b9ff, #59d941, #f0f0f0)"
      }} />
      <div className="overflow-hidden w-full bg-gray-100 py-1">
        <div
          className="flex items-center flex-nowrap gap-8"
          style={{
            display: "flex",
            flexWrap: "nowrap", // Ensures logos stay in a single row
            whiteSpace: "nowrap",
            transform: `translateX(${translateX}px)`,
            transition: "transform 0s linear",
          }}
        >
          {[...images, ...images].map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Logo ${index + 1}`}
              className="mx-2"
              style={{
                height: "auto", // Maintains aspect ratio
                width: "80px", // Adjust as needed
                flexShrink: 0, // Prevents images from shrinking
                
              }}
            />
          ))}
        </div>
      </div>
      {/* <hr style={{
        border: 0,
        height: "3px",
        backgroundImage: "linear-gradient(to right, #f0f0f0, #00b9ff, #59d941, #f0f0f0)"
      }} /> */}
     
    </>
  );
}

const styles = {
  container: {
    display: 'flex', // Flexbox to create side-by-side layout
    margin: '0 auto',
    maxWidth: '1200px',
    padding: '15px',
  },
  mainContent: {
    flex: 3, // Main content takes 3/4 of the available space
    marginRight: '20px',
  },
  // sidebar: {
  //   maxWidth: '300px',
  //   backgroundImage: "linear-gradient(to right, #A60065, #071d49)",
  //   padding: '5px',
  //   borderRadius: '8px',
  // },
  nav: {
    backgroundImage: "linear-gradient(to right, #A60065, #071d49)",
    padding: '10px',
    borderRadius: '8px',
  },
  navList: {
    display: 'flex',
    justifyContent: 'space-between', // Ensures even spacing
    alignItems: 'center', // Align items vertically
    width: '100%', // Ensure it takes full width
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  navItem: {
    width: '25%', // Ensures each item takes up 33% of nav width
    textAlign: 'center', // Center text
    position: 'relative',
    color: 'white',
    transition: 'background-color 0.3s ease, color 0.3s ease',

  },

  navLink: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '16px',
    display: 'block',
    padding: '10px',
    whiteSpace: 'nowrap',
  },
  dropdownMenu: {
    marginTop: 5,
    borderRadius: 10,
    position: 'absolute',
    top: '100%', // Position it directly below the "Adult" item
    left: 0,
    // backgroundColor: '#f5efe3',
    backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    minWidth: '200px',
    zIndex: 1,
    // border:"1px solid  #071d49",
    color: "#f5efe3"

  },
  dropdownLink: {
    display: 'block',
    padding: '10px 20px',
    textDecoration: 'none',
    color: '#071d49',
  },
};
